import script from "./DecisionBtn.vue?vue&type=script&lang=ts&setup=true"
export * from "./DecisionBtn.vue?vue&type=script&lang=ts&setup=true"

import "./DecisionBtn.vue?vue&type=style&index=0&id=dc6fb79c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc6fb79c"]])

export default __exports__